<!-- 运维视图: 值班日志 -->
<template>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>值班日志</span>
            <el-button v-if="logbook != null && logbook.status === 'DRAFT'" @click="save" style="float: right; padding: 3px 0;" type="text">
                <i class="el-icon-files">
                </i>
                保存
            </el-button>
        </div>
        <div class="daily" style="height:180px;">
            <div v-if="logbook == null">
                无值班日志
            </div>
            <el-form v-else>
                <el-form-item>
                    <el-input type="textarea" v-model="log" :disabled="logbook == null || logbook.status !== 'DRAFT'"
                              @blur="handleBlur"
                              maxlength="2000" show-word-limit placeholder="限2000字符">
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
    </el-card>
</template>

<script>

    import DutyServer from '@/api/duty';

    export default {
        name: "operation-board-duty-log",
        props: {
            logbook: {},
        },
        data() {
            return {
                log: null,
                oldLog: null,
            };
        },
        watch: {
            logbook: {
                deep: true,
                immediate: true,
                handler() {
                    this.load();
                }
            },
        },
        methods: {
            async load() {
                let logbook = this.logbook;
                let log;
                log = logbook == null ? null : logbook.log;
                /*if (log == null || log === '') {
                    this.$message.warning('无值班日志');
                }*/
                this.log = log;
                this.oldLog = log == null ? null : String(log);
                return Promise.resolve(log);
            },
            async save() {
                let logbook = this.logbook;
                let logbookId = logbook == null ? null : logbook.logbookId;
                let log = this.log;
                if (logbookId != null) {
                    let response = await DutyServer.logbook.updateLog(logbookId, log);
                    if (response.status === 200 && response.data.code === 200) {
                        log = response.data.result;
                        this.log = log;
                        this.oldLog = log == null ? null : String(log);
                        this.$message.success('值班日志保存成功！');
                    } else {
                        this.$message.error(response.data.message);
                        return Promise.reject(response.data.message);
                    }
                }
                return Promise.resolve(log);
            },
            handleBlur() {
                if (this.log !== this.oldLog) {
                    this.$confirm('值班日志已修改，确定保存吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.save();
                    }, () => {
                        // this.log = this.oldLog == null ? null : String(this.oldLog);
                    });
                }
            },
        },
    }
</script>

<style scoped>

</style>
